/* eslint-disable react/jsx-one-expression-per-line */
import { Checkbox, ConfigProvider, Radio } from 'antd';
import React, { useEffect, useState } from 'react';

import TransparentButton from '@/atoms/button-transparent';
import { useIsExactChecked } from '@core/offices/actions/properties/filterActions';
import { FILTER_PREVIEW_TYPE, FilterComponentInput } from '@core/offices/types';

const OptionsList = (props: FilterComponentInput) => {
  const { valuePrefix } = useIsExactChecked(props.filter);

  const [selectedCards, setSelectedCards] = useState<string[]>([]);

  const selectCard = (value: string) => {
    if (props.filter.isMultiSelect === '1') {
      if (selectedCards.includes(value)) {
        const newCards = selectedCards.filter((card) => card !== value);
        setSelectedCards(newCards);
        props.handleChange(newCards);
      } else {
        props.handleChange([...selectedCards, value]);
        setSelectedCards([...selectedCards, value]);
      }
    } else {
      setSelectedCards([value]);
      props.handleChange([value]);
    }
  };

  useEffect(() => {
    if (!props.value) {
      setSelectedCards([]);
    }
  }, [props.value]);

  if (props.filter.preview === FILTER_PREVIEW_TYPE.CARD) {
    return (
      <div className="flex w-full gap-1 flex-wrap flex-row justify-between items-center">
        {props.filter.options.map((option) => (
          <TransparentButton
            key={option.value}
            onClick={() => selectCard(option.value as string)}
            className={`w-1/6 cursor-pointer text-sm aspect-square bg-[#00000010] hover:!bg-[#00000010] rounded-md flex justify-center items-center text-center${
              selectedCards.includes(option.value as string)
                ? ' !bg-main text-white border-[2px] border-solid border-secondary'
                : ''
            }`}
          >
            {props.filter.isMultiSelect === '1' ? '' : valuePrefix} {option.label}
          </TransparentButton>
        ))}
      </div>
    );
  }
  if (props.filter.isMultiSelect === '1') {
    return (
      <Checkbox.Group
        className="w-full"
        value={props.value}
        onChange={(v) => props.handleChange(v)}
        options={props.filter.options}
      />
    );
  }
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: 'var(--secondary)',
        },
      }}
    >
      <Radio.Group
        className="w-full flex flex-col gab-2"
        value={props.value}
        onChange={(v) => props.handleChange(v.target.value)}
        options={props.filter.options}
      />
    </ConfigProvider>
  );
};

export default OptionsList;
